import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { Company } from 'src/app/classes/Company.class';
import { User } from 'src/app/classes/User.class';
@Component({
  selector: 'home-screen',
  templateUrl: `./home.screen.html`,
  styleUrls: ['./home.screen.scss'],
})
export class HomeScreenComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<Company>;
  displayedColumns: string[];
  companies: Company[];
  searchTerm = '';
  userDeleted = false;
  modalText = '';

  constructor(private userApiService: UserApiService, private router: Router) {}

  async ngOnInit() {
    const companies = await this.userApiService.getRegistrationRequests();
    this.displayedColumns = [
      'firstName',
      'lastName',
      'email',
      'requestForCompanyName',
      'requestDate',
      'details',
      'delete',
    ];
    this.dataSource = new MatTableDataSource<Company>(companies.data);
    console.log(this.dataSource);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  viewCompany(companyId: number) {
    this.router.navigateByUrl(`companies/${companyId}`);
  }

  filterResults() {
    this.dataSource.filter = this.searchTerm.trim().toLowerCase();
  }

  viewRegistrationRequest(userId: number) {
    this.router.navigateByUrl(`/users/${userId}`);
  }

  async deleteUser(userId: number) {
    const response = await this.userApiService.deleteUser(userId);
    if (!response.code) {
      this.setModalText('response.delete_user');
      this.userDeleted = true;
      location.reload();
      setTimeout(() => {
        this.userDeleted = false;
      }, 2700);
    }
  }

  checkSyncStatus(user: User) {
    if (user.role !== 'mowa_admin' && (!user.magentoCustomerId || !user.requestForCompanyName)) {
      return true;
    }
  }

  closeModal() {
    this.userDeleted = false;
  }

  setModalText(val: string) {
    this.modalText = val;
  }
}
